<div
  class="accordion-container"
  [attr.data-variant]="variant"
  [attr.data-size]="size"
  [attr.data-open]="isOpen"
  [attr.data-disabled]="disabled"
>
  <ng-content select="umss-accordion-trigger"></ng-content>
  <ng-content select="umss-accordion-content"></ng-content>
</div>
